module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_en.c98dc0ad.png";